import React from 'react'
import { createRoot } from 'react-dom/client'
import StudentAnalytics from './components/StudentAnalytics'

const pathArray = window.location.pathname.split('/')
const coursenum = pathArray[3]
const initialChapterFilter = pathArray[4] === undefined ? '' : pathArray[4]
const initialStudentFilter = pathArray[5] === undefined ? '' : pathArray[5]

export let startApp = () => {
  const root = createRoot(document.getElementById('react-app'))
  root.render(
    <StudentAnalytics
      coursenum={coursenum}
      initialStudentFilter={initialStudentFilter}
      initialChapterFilter={initialChapterFilter}
    />
  )
}
